import { FC, PropsWithChildren } from 'react';

import { dom } from 'app/utils';
import { IComponent } from '../types';

export interface IForm extends PropsWithChildren<IComponent> {
  action?: string;
  method?: string;

  responsive?: boolean;

  onChange?: (values: any) => void;
  onSubmit?: (values: any) => void;
}

export const Form: FC<IForm> = ({ id, className, style, disabled, action, method, children, responsive, onSubmit }) => {
  const form: any = { id, style, disabled, action, method, // onSubmit,
    className: dom.className('i-component', 'i-form', { 'i-responsive': responsive }, className),
  };

  const body: any = {
    className: dom.className('i-body'),
  };

  return (
    <div { ...form }>
      <div { ...body }>
        { children }
      </div>
    </div>
  );
}
